module.exports = __webpack_public_path__ + "img/UVI.fb4d3cb3.svg";